import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useModals } from '../modalStack/ModalProvider'
import i18n from 'senf-shared/utils/i18n'
import LanguageSettings from './LanguageSettings'
import { Project } from 'senf-shared/types'
import Button from '../../core/button/Button'
import { useIsMobile } from '../../../hooks/customDeviceDetect'
import { cn } from '../../../util/classNameConstructor'

const LanguageButton = ({project, size = "md", classNameWrapper, className}: {project: Project, size?: "md" | "lg", classNameWrapper?: string, className?: string}) => {
    const {openModal} = useModals()
    const {t} = useTranslation("languages")
    const isMobile = useIsMobile()
    

    return (
        <Button
            text=" "
            size={size}
            variant="outline"
            className={cn("rounded-full bg-white", className)}
            leadingIcon={`locales/${i18n.resolvedLanguage}`}
            aria-label={t("util:adjust", {
                val: t("global:language"),
            })}
            classNameWrapper={classNameWrapper}
            trailingIcon="arrowhead-down-md"
            onClick={() =>
                openModal(<LanguageSettings project={project} />, {
                    id: "languageModal",
                    title: t("util:adjust", {
                        val: t("global:language"),
                    }),
                    swipe: !!isMobile,
                    zIndex: 9999999999,
                })
            }
        />
    )
}

export default React.memo(LanguageButton)

